
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promocoes/menor-preco",
      function () {
        return require("private-next-pages/promocoes/menor-preco.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promocoes/menor-preco"])
      });
    }
  